import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../sections/Footer/Footer';
import SEO from '../../components/SEO/SEO';
import { getJobPostingSchema } from '../../components/SEO/schema';
import teamPhoto from '../../assets/home/team-photo.jpg';
import jobsData, { JOBS_EMAIL } from './JobsData';
import './Karriere.scss';

const Karriere = () => {
    return (
        <>
            <SEO
                title="Karriere | Zahnarztpraxis Roman Boretskyi"
                description="Jobs in der Zahnarztpraxis Roman Boretskyi in Tönisvorst: Wir suchen eine ZFA / Prophylaxeassistentin (m/w/d) in Teilzeit oder als Minijob."
                path="/karriere"
                jsonLd={jobsData.map((job) => getJobPostingSchema(job, JOBS_EMAIL))}
            />
            <Navbar />

            <main className="karriere">
                <header className="karriere-intro container">
                    <h1>Arbeiten in unserer Praxis</h1>
                    <figure className="karriere-photo">
                        <img src={teamPhoto} alt="Das Praxisteam der Zahnarztpraxis Roman Boretskyi" width="1915" height="821" />
                    </figure>
                </header>

                {jobsData.map((job) => (
                    <article key={job.id} id={job.id} className="job container">
                        <h2 className="job-title">{job.title}</h2>

                        <div className="row">
                            <aside className="col-lg-4">
                                <dl className="job-facts">
                                    {job.facts.map((fact) => (
                                        <div key={fact.label}>
                                            <dt>{fact.label}</dt>
                                            <dd>{fact.value}</dd>
                                        </div>
                                    ))}
                                </dl>
                            </aside>

                            <div className="col-lg-8 job-body">
                                {job.intro.map((paragraph, index) => (
                                    <p key={index} className={index === 0 ? 'job-lead' : undefined}>{paragraph}</p>
                                ))}

                                <h3>Das erwartet dich bei uns</h3>
                                <dl className="job-benefits">
                                    {job.benefits.map((benefit) => (
                                        <div key={benefit.title}>
                                            <dt>{benefit.title}</dt>
                                            <dd>{benefit.text}</dd>
                                        </div>
                                    ))}
                                </dl>

                                <h3>Das bringst du mit</h3>
                                <ul className="job-requirements">
                                    {job.requirements.map((requirement) => (
                                        <li key={requirement}>{requirement}</li>
                                    ))}
                                </ul>
                            </div>
                        </div>

                        <div className="job-apply">
                            <p>
                                Klingt nach deinem neuen Traumjob? Dann mach es dir einfach!
                                Schick uns deinen Lebenslauf an
                            </p>
                            <a
                                className="job-apply__email"
                                href={`mailto:${JOBS_EMAIL}?subject=${encodeURIComponent(`Bewerbung: ${job.title}`)}`}
                            >
                                {JOBS_EMAIL}
                            </a>
                            <p className="job-apply__closing">Wir freuen uns darauf, dich kennenzulernen!</p>
                        </div>
                    </article>
                ))}
            </main>
            <Footer />
        </>
    );
};

export default Karriere;
